module.exports = __webpack_public_path__ + "img/part7.191636c0.png";